import { useState } from 'react';
import { useAuth } from 'react-oidc-context';

export default function LoginForm({ onCancel, onSuccess }) {
  const auth = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | error
  const [message, setMessage] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();

    if (!username || !password) {
      setStatus('error');
      setMessage('username and password are required');
      return;
    }

    setStatus('submitting');
    setMessage('');

    // Note: signinResourceOwnerCredentials does NOT reject/throw on a
    // failed login - react-oidc-context's internal navigator wrapper
    // catches the error itself, stashes it on `auth.error`, and resolves
    // to `null` instead (see node_modules/react-oidc-context's
    // AuthProvider `navigatorKeys` wrapper). So the resolved value - not
    // a caught exception - is what tells us whether this succeeded.
    const user = await auth.signinResourceOwnerCredentials({ username, password });

    if (user) {
      setPassword('');
      onSuccess?.();
      return;
    }

    setStatus('error');
    setMessage('invalid username or password');
  }

  return (
    <form className="terminal-box" onSubmit={handleSubmit}>
      <p className="form-title">== SIGN IN ==</p>

      <label className="form-row" htmlFor="login-username">
        <span>USERNAME:</span>
        <input
          id="login-username"
          name="username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value.toLowerCase())}
          disabled={status === 'submitting'}
          spellCheck="false"
          autoFocus
        />
      </label>

      <label className="form-row" htmlFor="login-password">
        <span>PASSWORD:</span>
        <input
          id="login-password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={status === 'submitting'}
        />
      </label>

      {status === 'error' && <p className="error-line">! {message}</p>}

      <div className="button-row">
        <button type="submit" className="retro-button" disabled={status === 'submitting'}>
          {status === 'submitting' ? 'SUMMONING...' : 'SIGN IN'}
        </button>
        <button
          type="button"
          className="retro-button retro-button--ghost"
          onClick={onCancel}
          disabled={status === 'submitting'}
        >
          CANCEL
        </button>
      </div>
    </form>
  );
}
